import { Collection } from 'modules/core/lib/mobx-rest'

import AttendancePolicy from 'modules/attendance/store/models/AttendancePolicy'

class AttendancePolicies extends Collection<AttendancePolicy> {
  get cacheKey(): string {
    return 'attendancePolicies'
  }

  model() {
    return AttendancePolicy
  }

  hasEmployees(ids: string[]): boolean {
    return this.some(
      (policy) =>
        ids.some((id) => policy.attributes.id === id) && policy.attributes.employees.length > 0
    )
  }
}

const singleton: AttendancePolicies = new AttendancePolicies()

export default singleton
